<template>
    <el-dialog id="ipipcSearchDialog" :title="title" :visible.sync="dialogVisible" :width="width" @close="closeDialog" :close-on-click-modal="false"  :append-to-body="appendToBody">
        <el-form label-width="110px" size="mini" @submit.native.prevent>
                <slot name="operate">
                    <el-row :gutter="20">
                        <el-col :span="24" style="padding-bottom: 10px;">
                            <div v-if="!!showError.isShow">
                                <el-alert :title="showError.message" type="warning" show-icon @close="showError.isShow = false"></el-alert>
                            </div>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item label="IPC分类查询：">
                                <el-input v-model="ipc.value" id="searchIpc" @focus="showError.isShow = false" @keyup.enter.native="submitIpc">
                                    <el-button icon="el-icon-search" @click="submitIpc" slot="append"></el-button>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10" class="choice">
                            <el-radio-group v-model="ipc.key">
                                <el-radio label="ipc">按分类号查询</el-radio>
                                <el-radio label="note">按内容查询</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </slot>
				<el-row>
					<el-col :span="24" class="mt15">
						<el-input id="ipcSearchContent" v-model="ipcValue2" type="textarea" @change="handleChangeTextarea"></el-input>
                        <el-button class="mt15 pull-right" type="primary" size="small" @click="clearTextarea">清空</el-button>  
                    </el-col>
				</el-row>
        </el-form>
        <div class="tree-box">
            <slot name="extend"></slot>
            <ip-tree :dataSet="treeData" :edit="treeEdit" 
                        @nodeClick="handleNodeClick"
                        @checkboxChangeEvent="checkboxChangeEvent" 
                        @expandEvent="handleExpandEvent"  
                        @removeNode="handleRemoveNode"
                        @renameNode="handleRenameNode"
                        @addNode="handleAddNode"></ip-tree>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
            <el-button  size="small" type="primary" @click="submitIPCExp">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name:'ipIpcSearchModel',
    props:{
        visible: {
            type: Boolean,
            default: false
        },
        width:{
            type: String,
            default: ''
        },
        treeData:{
            type:Array,
            default(){
                return []
            }
        },
        showError:{
            type:Object,
            default(){
                return {}
            }
        },
        ipcValue:{
            type:String,
            default:''
        },
        title:{
            type:String,
            default:'IPC分类号查询'
        },
        treeEdit:{
            type:Object,
            default(){
                return {}
            }
        },
        appendToBody:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return{
            ipc:{
                key : "ipc",
                value : ""
            },
            highlightNode:null,
            ipcValue2:''
        }
    },
    watch:{
        ipcValue(value){
            this.ipcValue2 = value;
        },
        visible(newvalue){
            if (!newvalue) {
                this.ipc.value = '';
            }
        }
    },
    computed:{
        dialogVisible:{
             // getter
            get(){
                return this.visible
            },
             // setter
            set(){
            }
        }
    },
    methods:{
        closeDialog(){
            this.$emit('close-dialog');
        },
        submitIPCExp(){
            this.$emit('submit-ipc-exp',this.ipcValue2);
        },
        submitIpc(){
            this.$emit('ipc-search',this.ipc);
        },
        handleExpandEvent(node){
            this.$emit('expand-event',node);
        },
        handleNodeClick(node){
            if (this.highlightNode !== null) {
                this.highlightNode.highlight = false;
            }
            this.$set(node,'highlight',true);
            this.highlightNode = node;
            this.$emit('node-click',node);
        },
        checkboxChangeEvent(node,father,changeList,parent){
            console.log(node,father,changeList,parent);
            this.$emit('checkbox-change',node,father,changeList,parent);
        },
        handleChangeTextarea(){
            this.$emit('change-textarea',this.ipcValue2);
        },
        clearTextarea(){
            this.ipcValue2 = '';
            this.$emit('clear-textarea');
        },
        handleRemoveNode(node,parent){
            this.$emit('remove-node',node,parent);
        },
        handleRenameNode(node){
            this.$emit('rename-node',node);
        },
        handleAddNode(node){
            this.$emit('add-node',node);
        }
    }
}
</script>
<style lang="scss">
#ipipcSearchDialog {
    .el-dialog__body{
        padding: 15px 20px;
        .el-form-item--mini.el-form-item{
            margin-bottom: 8px;
        }
    }
    .el-dialog__header {
        background: $theme-color;
        height: 40px;
        line-height: 40px;
        padding: 0px 15px;
        box-sizing: border-box;
        .el-dialog__title{
            font-size: 16px;
            color: #ffffff;
        }
        .el-dialog__headerbtn{
            top: 12px;
        .el-dialog__close{
            color: #ffffff;
        }
        }
    }
}
</style>
<style lang="scss" scoped>
    .mt15{
        margin-top: 15px;
    }
    .choice{
        padding: 4px 0 0 0;
    }
    .tree-box{
        margin:8px 0 0 0;
        max-height: 350px;
        overflow-y: auto;
    }
</style>

